import {createDataTable} from '../helpers';
import {DATA_PATH} from '../constants';
import {getJsonUrl} from '../../../app.config';

const getData = tier =>
  fetch(getJsonUrl(tier) + DATA_PATH)
    .then(res => res.json())
    .then(res => createDataTable(res));

const api = {getData};

export default api;
